import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=387744de&"
import script from "./Bundle.vue?vue&type=script&lang=js&"
export * from "./Bundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports